<template>
  <v-dialog v-model="estado_dialog" width="500" persistent>
    <v-card>
      <v-card-title> Aseguradora LA CEIBA </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="aviso"
                label="Aviso"
                outlined
                dense
                hide-details
                :rules="rule"
                :disabled="aviso_dis"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="grupo"
                label="Grupo"
                outlined
                dense
                hide-details
                :rules="rule"
                :disabled="grupo_dis"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="analista"
                label="Analista"
                outlined
                dense
                hide-details
                :rules="rule"
                :disabled="analista_dis"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="agente"
                label="Agente"
                outlined
                dense
                hide-details
                :rules="rule"
                :disabled="agente_dis"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="reclamo"
                label="Reclamo"
                outlined
                dense
                hide-details
                :rules="rule"
                :disabled="reclamo_dis"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="cerrarDialog()">Cerrar</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="validarId()" v-if="campos_completos"
          >Guardar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      valid: true,
      id_cierre_ceiba: 0,
      reclamo: "",
      agente: "",
      analista: "",
      aviso: "",
      grupo: "",
      estatus_asistencia: "",
      rule: [(v) => !!v || "Campos obligatorios"],
      campos_completos: true,
      ////
      reclamo_dis: false,
      agente_dis: false,
      analista_dis: false,
      aviso_dis: false,
      grupo_dis: false,
    };
  },
  props: ["estado_dialog", "id_cabina"],
  methods: {
    listarDatos(estatus_asistencia) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      this.estatus_asistencia = estatus_asistencia;

      axios
        .get("api/CierreLaCeiba/Listar/" + this.id_cabina, configuracion)
        .then((response) => {
          if (response.data.length > 0) {
            this.id_cierre_ceiba = response.data[0].id_cierre_ceiba;
            this.reclamo = response.data[0].reclamo;
            this.agente = response.data[0].agente;
            this.analista = response.data[0].analista;
            this.aviso = response.data[0].aviso;
            this.grupo = response.data[0].grupo;

            if (
              this.$store.state.usuario.idUsuario == 1 ||
              this.$store.state.usuario.idUsuario == 5 ||
              this.$store.state.usuario.idUsuario == 1007 ||
              this.$store.state.usuario.idUsuario == 1009 ||
              this.$store.state.usuario.idUsuario == 1011
            ) {
              return;
            }

            if (
              this.reclamo.length > 0 &&
              this.agente.length > 0 &&
              this.analista.length > 0 &&
              this.aviso.length > 0 &&
              this.grupo.length > 0
            ) {
              this.campos_completos = false;
            }

            if (this.reclamo.length > 0) {
              this.reclamo_dis = true;
            }
            if (this.agente.length > 0) {
              this.agente_dis = true;
            }
            if (this.analista.length > 0) {
              this.analista_dis = true;
            }
            if (this.aviso.length > 0) {
              this.aviso_dis = true;
            }
            if (this.grupo.length > 0) {
              this.grupo_dis = true;
            }
          }
        });
    },
    validarId() {
      if (this.id_cierre_ceiba == 0) {
        this.crearRegistro();
      } else if (this.id_cierre_ceiba > 0) {
        this.actualizarRegistro();
      }
    },
    crearRegistro() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .post(
          "api/CierreLaCeiba/Crear",
          {
            idCabina: this.id_cabina,
            reclamo: this.reclamo,
            agente: this.agente,
            analista: this.analista,
            aviso: this.aviso,
            grupo: this.grupo,
          },
          configuracion
        )
        .then(() => {
          this.cerrarDialog();
        });
    },
    actualizarRegistro() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      if (this.estatus_asistencia == "FINALIZADO") {
        if (this.$refs.form.validate()) {
          axios
            .put(
              "api/CierreLaCeiba/Actualizar",
              {
                id_cierre_ceiba: this.id_cierre_ceiba,
                idCabina: this.id_cabina,
                reclamo: this.reclamo,
                agente: this.agente,
                analista: this.analista,
                aviso: this.aviso,
                grupo: this.grupo,
              },
              configuracion
            )
            .then(() => {
              this.cerrarDialog();
            });
        }
      } else {
        axios
          .put(
            "api/CierreLaCeiba/Actualizar",
            {
              id_cierre_ceiba: this.id_cierre_ceiba,
              idCabina: this.id_cabina,
              reclamo: this.reclamo,
              agente: this.agente,
              analista: this.analista,
              aviso: this.aviso,
              grupo: this.grupo,
            },
            configuracion
          )
          .then(() => {
            this.cerrarDialog();
          });
      }
    },
    cerrarDialog() {
      this.$emit("update:estado_dialog", !this.estado_dialog);
      this.id_cierre_ceiba = 0;
      this.reclamo = "";
      this.agente = "";
      this.analista = "";
      this.aviso = "";
      this.grupo = "";
      this.$refs.form.resetValidation();
    },
  },
};
</script>